import tabsClassNames from '@apps/Application/widgets/ApplicationTabs/styles.module.scss'
import ratingClassNames from '@apps/ApplicationRating/styles.module.scss'
import { useAppSelector, useTranslate } from '@common/hooks'
import Header from '@layouts/Header'
import cx from 'classnames'
import { useRouter } from 'next/router'
import Skeleton from 'react-loading-skeleton'

import classNames from './styles.module.scss'


export default function ApplicationLoader(): JSX.Element {
  const router = useRouter()
  const tab = router.asPath.split('?')[0]
  const { translate } = useTranslate()
  const isTestbed = useAppSelector(store => store.common.data?.config?.ASP_TESTBED === 'True')
  return (
    <>
      <Header className={classNames.header}>
        <>
          <Skeleton className={classNames.skeletonHeader} duration={0.5} containerClassName={classNames.skeletonHeaderContainer}/>
        </>
      </Header>
      <main className={cx(classNames.main, {
        [classNames.testbed]: isTestbed,
      })}>
        <div className={classNames.appInfo}>
          <Skeleton className={classNames.skeletonTitle} duration={0.5} containerClassName={classNames.skeletonTitleContainer}/>
          <div className={classNames.appDetailInfo}>
            <Skeleton className={classNames.skeletonAuthor} duration={0.5} containerClassName={classNames.skeletonAuthorContainer}/>
            <Skeleton className={classNames.skeletonUpdatesInfo} duration={0.5} containerClassName={classNames.skeletonUpdatesInfoContainer}/>
          </div>
        </div>
      </main>
      <section className={tabsClassNames.tabs}>
        <header className={tabsClassNames.header}>
          <button
            data-test="details-tab"
            className={cx(tabsClassNames.tab, tab.endsWith('settings') && tabsClassNames.active)}
          >
            {translate('Details')}
          </button>
          <button
              data-test="reviews-tab"
              className={cx(tabsClassNames.tab, tab.endsWith('reviews') && tabsClassNames.active)}
            >
              {translate('Reviews')}
            </button>
        </header>
        {tab.endsWith('settings') && (
          <>
            <Skeleton className={classNames.skeletonDescription} duration={0.5} containerClassName={classNames.skeletonDescriptionContainer}/>
            <Skeleton className={classNames.skeletonSetting} duration={0.5}/>
          </>
        )}
        {tab.endsWith('reviews') && (
          <div className={ratingClassNames.wrapper}>
            <div className={ratingClassNames.scoreRow}>
              <Skeleton className={ratingClassNames.skeletonScore} duration={0.5}/>
              <Skeleton className={ratingClassNames.skeletonBars} duration={0.5}/>
            </div>
            <Skeleton className={ratingClassNames.skeletonReviews} duration={0.5}/>
            <Skeleton className={ratingClassNames.skeletonReviews} duration={0.5}/>
            <Skeleton className={ratingClassNames.skeletonReviews} duration={0.5}/>
          </div>
        )}
      </section>
    </>
  )
}
